const MAX_SCREENSHOT_SIZE_BYTES = 10 * 1024 * 1024;

export const MAX_SCREENSHOT_COUNT = 5;
export const SCREENSHOT_FILE_ACCEPT = "image/png,image/jpeg,image/webp";
export const SCREENSHOT_VALIDATION_ERROR =
  "Some files were skipped. Use PNG, JPG, or WebP images up to 10 MB.";

export type FeedbackAttachment = {
  data: Uint8Array;
  filename: string;
  contentType: string;
};

export function isValidScreenshotFile(file: File) {
  return (
    file.type.startsWith("image/") && file.size <= MAX_SCREENSHOT_SIZE_BYTES
  );
}

export async function fileToAttachment(
  file: File,
): Promise<FeedbackAttachment> {
  return {
    data: new Uint8Array(await file.arrayBuffer()),
    filename: file.name,
    contentType: file.type || "application/octet-stream",
  };
}
